import { ROUTE } from "../../../routes";
import { ButtonTypeTokens, ColorTokens } from "@voltmoney/schema";
import { Platform } from 'react-native';
import SharedPropsService from "../../../SharedPropsService";
import { ConfigTokens, ConfigValues, getAppHeader, } from "../../../configs/config";
import { api } from "../../../configs/api";
import { addCommasToNumber, allowDynamicLimitFromBE, getParameters, isFromAndroidWebview, isFromTDLPlatform } from "../../../configs/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
let value = ConfigValues.MinimumAmountAllowed.toString();
let updateCounter = 0;
export const goKfin = async (action, _datastore, { instrumentTrack, navigate, goBack, setDatastore }) => {
    instrumentTrack("VIEW_PORTFOLIO_BUTTON_CLICKED", {
        "type": action.payload.value,
        "page": "unlock_credit_limit_screen"
    });
    await navigate(ROUTE.PORTFOLIO_FROM_RTA, {
        assetRepository: action.payload.value,
    });
};
export const goPortfolio = async (action, _datastore, { instrumentTrack, navigate, goBack, setDatastore }) => {
    await navigate(ROUTE.SET_CREDIT_LIMIT);
};
export const needHelp = async (action, _datastore, { instrumentTrack, navigate, goBack, setDatastore }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goHome = async (action, _datastore, { instrumentTrack, navigate, navigateWithClear, goBack, setDatastore }) => {
    if (await AsyncStorage.getItem("application_id") !== null) {
        await navigate(ROUTE.MANAGE_LIMIT_LANDING);
    }
    else {
        if (await SharedPropsService.showHome()) {
            const reFetch = true;
            await navigateWithClear(ROUTE.BORROWER_LANDING_SCREEN, { reFetch });
        }
        else {
            window.parent.postMessage("Exit callback", "*");
            if (isFromAndroidWebview() && isFromTDLPlatform()) {
                window.open("closeActivity", "_parent");
            }
            // @ts-ignore
            window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closeActivity");
        }
    }
};
export const goToNext = async (action, _datastore, { navigate, goBack, setDatastore, instrumentTrack, network }) => {
    const allowDynamicLimitFromBEFlag = await allowDynamicLimitFromBE();
    let isDarkMode = null;
    //@ts-expect-error
    const showLessLimitV2 = action?.payload?.showLessLimit;
    if (Platform.OS === 'web') {
        let params = getParameters(window?.location?.href);
        isDarkMode = params.isDarkMode;
    }
    updateCounter = updateCounter + 1;
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    await setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, "continue", {
        loading: true
    });
    const response = await network.post(api.assignLender, {
        applicationId: applicationId,
    }, { headers: await getAppHeader() });
    if (response.status === 200) {
        if (allowDynamicLimitFromBEFlag) {
            const minimumEligibleLimitFromResponse = response?.data?.minimumEligibleLimit;
            const minimumEligibleLimit = minimumEligibleLimitFromResponse !== undefined ? minimumEligibleLimitFromResponse : 25000;
            await SharedPropsService.setMinimumEligibleLimitData(minimumEligibleLimit);
            const isEligible = minimumEligibleLimit?.isEligible;
            const nonEligibleDisplayReason = minimumEligibleLimit?.nonEligibleDisplayReason;
            if (isEligible === false) {
                setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'showLessLimitCard', {
                    hide: false
                });
                setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'infoLabel', {
                    label: `${nonEligibleDisplayReason}`
                });
                setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'amountcontinue', {
                    type: ButtonTypeTokens.LargeOutline,
                    labelColor: ColorTokens.Grey_400
                });
            }
            else if (isEligible === true) {
                setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'showLessLimitCard', {
                    hide: true
                });
                setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'infoLabel', {
                    label: ``
                });
                setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'amountcontinue', {
                    type: ButtonTypeTokens.LargeFilled,
                    labelColor: ColorTokens.White
                });
            }
        }
        else {
            setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'showLessLimitCard', {
                hide: !showLessLimitV2
            });
        }
        const user = await SharedPropsService.getUser();
        const authCAS = await SharedPropsService.getAuthCASResponse();
        const pledgeLimitResponse = {
            data: await network
                .get(`${api.pledgeLimit}${applicationId}`, { headers: await getAppHeader() })
                .then(response => {
                return response.data;
            }),
        };
        if (pledgeLimitResponse.data) {
            await SharedPropsService.setAuthCASResponse(pledgeLimitResponse.data);
        }
        if (!allowDynamicLimitFromBEFlag && Platform.OS !== 'web') {
            const isEnhancedLimit = await AsyncStorage.getItem("application_id") !== null && !(await SharedPropsService.getElevateFlow());
            let enhanceLimit = 25000;
            const availableCreditAmount = pledgeLimitResponse.data.stepResponseObject.availableCreditAmount || 0;
            if (isEnhancedLimit) {
                if (availableCreditAmount > enhanceLimit) {
                    await setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'amountcontinue', {
                        type: ButtonTypeTokens.MediumFilled,
                        labelColor: ColorTokens.White
                    });
                }
                else {
                    await setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'amountcontinue', {
                        type: ButtonTypeTokens.LargeOutline,
                        labelColor: ColorTokens.Grey_400
                    });
                }
            }
            else {
                if (availableCreditAmount > 25000) {
                    await setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'amountcontinue', {
                        type: ButtonTypeTokens.MediumFilled,
                        labelColor: ColorTokens.White
                    });
                }
                else {
                    await setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, 'amountcontinue', {
                        type: ButtonTypeTokens.LargeOutline,
                        labelColor: ColorTokens.Grey_400
                    });
                }
            }
        }
        const updateAvailableCASMap = {};
        const availableCreditAmount = pledgeLimitResponse.data.stepResponseObject.availableCreditAmount ||
            0;
        const creditLimitLow = availableCreditAmount < 25000;
        const totalPortfolioAmount = pledgeLimitResponse.data.stepResponseObject.totalPortfolioAmount ||
            0;
        const availableCAS = pledgeLimitResponse.data.stepResponseObject.availableCAS || [];
        await SharedPropsService.setCasListOriginal(availableCAS);
        const stepResponseObject = pledgeLimitResponse.data.stepResponseObject;
        //
        stepResponseObject.availableCAS.map((item, index) => {
            const key = `${item.isinNo}-${item.folioNo}`;
            item.pledgedUnits = item.totalAvailableUnits;
            updateAvailableCASMap[key] = item;
        });
        await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
        await SharedPropsService.setCreditLimit(availableCreditAmount);
        await setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, "amountCard", {
            limitAmount: `${addCommasToNumber(availableCreditAmount)}`,
            fetchedAmount: `${addCommasToNumber(totalPortfolioAmount)}`
        });
        await setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, "trial", {
            activeIndex: action.payload.activeIndex,
            updateCounter: updateCounter,
        });
        await setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, "creditTitle", {
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
        });
    }
    await setDatastore(ROUTE.MF_PLEDGE_PORTFOLIO, "continue", {
        loading: false
    });
    instrumentTrack("CONTINUE_TO_SET_CREDIT_LIMIT_BUTTON_CLICKED");
    console.warn('*** goToNext action triggered ***: ', action);
    console.log("action.payload.activeIndex: ", action.payload.activeIndex);
    // await navigate(ROUTE.MF_PLEDGE_PORTFOLIO, {
    //   activeIndex: action.payload.activeIndex,
    // });
};
export const getMoreMfPortfolio = async (action, _datastore, { navigate, instrumentTrack, ...props }) => {
    const assetRepoMap = {};
    /*** Get unique asset repository from the cas list */
    for (let i = 0; i < action.payload.casList.length; i++) {
        const item = action.payload.casList[i];
        assetRepoMap[item.assetRepository] = true;
    }
    instrumentTrack("REFRESH_PORTFOLIO_BUTTON_CLICKED", {
        "type": action.payload.value,
        "page": "unlock_credit_limit_screen"
    });
    /*** Change page view type LAYOUT.LIST to LAYOUT.MODAL */
    await SharedPropsService.setConfig(ConfigTokens.IS_MF_FETCH_BACK_ALLOWED, true);
    /*** switch between assetRepositoryType */
    const assetType = action.payload.value;
    /*** disable pan edit option */
    await SharedPropsService.setConfig(ConfigTokens.IS_PAN_EDIT_ALLOWED, false);
    await SharedPropsService.setConfig(ConfigTokens.IS_RTA_SWITCH_ENABLED, false);
    /*** Enable auto otp trigger when user lands on MF_Fetch */
    await SharedPropsService.setConfig(ConfigTokens.IS_MF_FETCH_AUTO_TRIGGER_OTP, true);
    /*** Go to re-fetch portfolio from other Asset Type **/
    await navigate(ROUTE.MF_FETCH_PORTFOLIO, {
        setIsUserLoggedIn: true,
        assetRepository: assetType,
    });
    /*** remove fetch more asset type option from UI */
};
export const goBack = async (action, _datastore, { navigate, navigateWithClear, goBack, setDatastore }) => {
    await navigateWithClear(ROUTE.MF_PLEDGE_PORTFOLIO);
};
